class NotificationTypes {
  static readonly TYPING_INDICATOR = 'twilio.ipmsg.typing_indicator';
  static readonly NEW_MESSAGE = 'twilio.channel.new_message';
  static readonly ADDED_TO_CHANNEL = 'twilio.channel.added_to_channel';
  static readonly INVITED_TO_CHANNEL = 'twilio.channel.invited_to_channel';
  static readonly REMOVED_FROM_CHANNEL = 'twilio.channel.removed_from_channel';
  static readonly CONSUMPTION_UPDATE = 'twilio.channel.consumption_update';
}

export { NotificationTypes };